<template>
  <div class="content">
    <div v-show="page.total === 0">
      <div class="kongImg">
        <img
          :src="
            $common.getResourceUrl('pcweb/pcKongStatus/img_dingdankong.png')
          "
        />
        <p>查询不到订单呦</p>
      </div>
    </div>
    <div class="listbox">
      <div v-for="(item, index) in list" :key="index" class="orderList">
        <div class="orderList-top">
          <div>
            <span v-if="item.create_time">{{ item.create_time }}</span>
            <span>订单编号：{{ item.order_sn }}</span>
          </div>
          <el-button type="text" @click="pushOrder(item.order_sn)"
            >查看详情</el-button
          >
        </div>
        <div v-for="(p, i) in item.products" :key="i" class="orderList-center">
          <!-- 课程 -->
          <div
            v-if="p.product_type === 'course'"
            class="orderList-center-item"
            :class="p.product_type"
          >
            <div class="orderList-center-1 flex">
              <el-image class="img" fit="cover" :src="p.product_info.cover" />
              <div class="imgNav">
                <div>
                  <i class="icon">{{ p.product_info.type_name }}</i
                  >{{ p.product_info.name }}
                </div>
                <div>{{ p.product_info.description }}</div>
              </div>
            </div>
            <div class="orderList-center-2">￥{{ p.product_price }}</div>
          </div>
          <!-- 服务 -->
          <div
            v-if="p.product_type === 'service'"
            class="orderList-center-item"
            :class="p.product_type"
          >
            <div class="orderList-center-1 flex">
              <el-image
                class="img"
                fit="cover"
                :src="p.product_info.image"
                style="width: 30px; height: 30px"
              />
              <div class="imgNav">
                <div>
                  {{ p.product_info.name
                  }}<span
                    style="color: #999999; margin-left: 15px; font-size: 14px"
                    >{{ p.product_info.description }}</span
                  >
                </div>
              </div>
            </div>
            <div class="orderList-center-2">￥{{ p.product_price }}</div>
          </div>
        </div>
        <div class="orderList-bottom">
          <span v-if="item.user_coupon_money > 0"
            >优惠：- ￥{{ item.user_coupon_money }}</span
          >
          <span v-if="item.pay_status == 1">付款：￥{{ item.pay_price }}</span>
        </div>
      </div>
    </div>
    <!-- 分页条 -->
    <el-pagination
      v-if="page.page_last > 1"
      :current-page="page.page"
      layout="prev, pager, next"
      :page-size="page.limit"
      :total="page.total"
      @current-change="pageChange"
      @size-change="limitChange"
    />
  </div>
</template>
<script>
import { getOrderList } from '@/network/request'
export default {
  // 过滤器
  filters: {
    filter1(item) {
      if (Number(item.refund_fee) === 0) {
        return '已完成'
      } else if (
        Number(item.refund_fee) > 0 &&
        Number(item.refund_fee) !== Number(item.product_price)
      ) {
        return '已部分退款'
      } else {
        return '已退款'
      }
    },
  },
  data() {
    return {
      page: {
        page: 1,
        limit: 8,
        page_last: 1,
        total: null,
      },
      list: [], // 订单列表
      // 订单完成状态
      statusShowTexts: {
        waitpay: '等待支付',
        cancel: '已取消',
        notake: '等待领取',
        refund: '已退款',
        done: '已完成',
      },
    }
  },
  computed: {
    // 获取状态文字
    statusText() {
      return (status) => {
        return this.statusShowTexts[status]
      }
    },
  },
  created() {
    this.getOrderList()
  },
  methods: {
    pageChange(e) {
      this.page.page = e
      this.getOrderList()
    },
    limitChange(e) {
      this.page.limit = e
      this.page.page = 1
      this.getOrderList()
    },
    // 获取用户的订单列表
    async getOrderList() {
      const { page, limit } = this.page
      const res = await getOrderList({ page, limit })
      this.list = res.data.result.data
      this.page.total = res.data.result.total
      this.page.page_last = res.data.result.page_last
    },
    // 跳转订单详情
    pushOrder(orderSn) {
      const routerJump = this.$router.resolve({
        path: '/orderDetails',
        query: { order_sn: orderSn },
      })
      window.open(routerJump.href, '_blank')
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding: 21px;
  // height: 710px;
}
.kongImg {
  text-align: center;
  padding-top: 80px;

  img {
    margin: auto;
    width: 500px;
  }
  p {
    text-align: center;
    margin-top: 20px;
    color: #bbb;
    font-size: 16px;
  }
}
.listbox {
  max-height: 600px;
  overflow-y: auto; // 关键
}
.orderList {
  border-radius: 4px;
  border: solid 1px #e7e7e7;
  margin-bottom: 20px;

  .orderList-top {
    padding: 16px 24px;
    background-color: #f8f9fa;
    display: flex;
    justify-content: space-between;
    span {
      margin-right: 20px;
      font-size: 15px;
      color: #787878;
    }
    .el-button {
      padding: 0;
    }
  }
  .orderList-bottom {
    padding: 16px 24px;
    text-align: right;
    & > span {
      margin-left: 20px;
    }
  }
  .orderList-center {
    padding: 0px 25px 0;
    border-bottom: 1px solid #eaeaea;
    border-width: 1px;
  }
  .orderList-center:last-child {
    border: 0;
  }
  .orderList-center-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    .orderList-center-1 {
      .img {
        width: 92px;
        height: 60px;
        background-color: #f8f9fa;
        border-radius: 3px;
        margin-right: 14px;
      }
      .imgNav {
        flex: 1;
        margin-right: 20px;
        div:nth-child(1) {
          color: #000;
          font-size: 16px;
        }
        div:nth-child(2) {
          font-size: 14px;
          color: #999999;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-top: 18px;
        }
        .icon {
          background-color: #ee8661;
          color: #fff;
          font-size: 12px;
          padding: 2px 6px;
          border-radius: 8px 0 8px 0;
          margin-right: 3px;
          font-style: normal;
        }
      }
    }
    .flex {
      display: flex;
      align-items: center;
    }
    .orderList-center-2 {
      font-size: 16px;
      color: #000000;
    }
    .numwidth {
      width: 80px;
    }
  }
}
.orderList:last-child {
  margin-bottom: 70px;
}
</style>
